import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';
import { ShortObject } from '../../project-misc/data/project/short-json-object';

@JsonObject('model.QBTransaction')
export class QBTransaction extends AbstractModel {
	@JsonProperty(Number, 'balance')
	balance?: number;

	@JsonProperty(Number, 'id')
	id: number;

	@JsonProperty(ShortObject, 'project')
	project?: ShortObject;

	@JsonProperty(String, 'qbId')
	qbId?: string;

	@JsonProperty(Number, 'totalAmt')
	totalAmt?: number;

	@JsonProperty(DateConverter, 'txnDate')
	txnDate?: Date;

	@JsonProperty(String, 'txnStatus')
	txnStatus?: string;

	@JsonProperty(String, 'type')
	type?: string;

	@JsonProperty(String, 'jobName')
	jobName?: string;

}
